export default "https://assets.stage.yurplan.com/yurplan-v1/dist/msg-box__icon--success.091189e60fd0840fe341c8ca6ecbb8ae.svg";